/**
 * Created by Ning Jiang on 2021-06-22.
 */

import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {DDayLayers, Layers} from "../../../view/DDayLayers";
import {gsap, TimelineLite} from "gsap";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {DDay} from "../../../DDay";
import {BigWinParticles} from "./BigWinParticles";

export class BigWinView {
    private _layer: StageLayer;
    private _texture: PIXI.spine.Spine | undefined;
    private _textureContainer: PIXI.Container;
    private _backgroundGFX: PIXI.Graphics;
    private _particles: BigWinParticles;


    constructor() {
        this._layer = DDayLayers.getLayer(Layers.WIN_PRESENTATIONS)!;
        this.createOverlay();
    }

    private createOverlay(): void {
        this._backgroundGFX = new PIXI.Graphics();
        this._backgroundGFX.visible = false;
        this._textureContainer = new PIXI.Container();
        this._particles = new BigWinParticles();
        this._particles.visible = false;
        this._particles.position.set(360, 700);
        this.setOverlayProps();
        this._layer.addChild(this._backgroundGFX, this._textureContainer, this._particles);
    }

    protected setOverlayProps(): void {
        if (this._backgroundGFX) {
            const bounds: ScreenBounds = NolimitApplication.screenBounds;
            this._backgroundGFX.clear();
            this._backgroundGFX.beginFill(0x000000, 0.7);
            this._backgroundGFX.drawRect(bounds.left - 600, bounds.top - 300, 3 * bounds.width, 3 * bounds.height);
            this._backgroundGFX.endFill();
        }
    }

    public getLevelAnimation(level: number, duration: number, isEndLevel: boolean): TimelineLite {
        const tl = gsap.timeline();
        if (!this._texture) {
            this.createBigWinTexture();
        }
        tl.add(() => {
            this._backgroundGFX.visible = true;
            this._backgroundGFX.alpha = 1;
            this._texture!.state.setAnimation(0, "bigwin_" + (level + 1), false);
            this._texture!.visible = true;
            this._texture!.alpha = 1;
            this._particles.visible = true;
            this._particles.alpha = 1;
            this._particles.play(level);
        });
        tl.to(this, {duration: 0.1});
        return tl;
    }

    public createBigWinTexture(): void {
        this._texture = new PIXI.spine.Spine(DDay.assetLoader.getSpineAsset("bigWin"));
        this._texture.position.set(360, 360);
        this._texture.visible = false;
        this._textureContainer.addChild(this._texture);
    }

    public playEnding(endLevel: number): void {
        // TODO:
        this._backgroundGFX.visible = false;
        this._textureContainer.removeChild(this._texture!);
        this._texture!.destroy();
        this._texture = undefined;
        this._particles.visible = false;
        this._particles.stop();
    }
}
